import { memo } from "react";
import styled from "styled-components";
import { Typography, Paper, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

const RoomNotfound = () => {
  const [t] = useTranslation();
  return (
    <Container>
      <Paper>
        <Box p={2}>
          <Typography variant="h5" align="center" gutterBottom>
            {t("お探しのルームは見つかりませんでした")}
          </Typography>
          <Typography variant="body2" align="center">
            {t("URLに誤りがないかご確認ください。")}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

const Container = styled.div`
  margin: auto auto;
`;

export default memo(RoomNotfound);
